import { Global } from "@emotion/react";

export const GlobalStyles = () => (
  <Global
    styles={`
      :root {
        --font-family: "Proxima Nova", "Helvetica Neue", sans-serif;
        --readable-color-on-dark: #FFFFFF;
        --readable-color-muted-on-dark: rgba(255,255,255,0.64);
        --readable-color-disabled-on-dark: rgba(255,255,255,0.5);
        --readable-color-on-light: #343536;
        --readable-color-muted-on-light: #666768;
        --readable-color-disabled-on-light: #BBBBBB;

        --readable-color: var(--readable-color-on-light);
        --readable-color-muted: var(--readable-color-muted-on-light);
        --readable-color-disabled: var(--readable-color-disabled-on-light);

        --background-color-disabled: var(--readable-color-muted);
        --border-color-active: var(--readable-color);
        --border-color-disabled: var(--readable-color-disabled);
      }

      * {
        box-sizing: border-box;
      }

      html {
        // Set a max font size to prevent text from being too large while still
        // meeting accessibility standards.
        font-size: clamp(16px, 1rem, 32px);
      }

      html, body {
        margin: 0;
        padding: 0;
      }

      html {
        height: 100%;
      }

      body {
        min-height: 100%;
      }

      body {
        font-family: var(--font-family);
        width: 100%;
      }

      #app-root {
        position: relative;
        height: 100%;
        min-height: 100%;
        min-height: 100dvh;
        z-index: 1;
      }

      body {
        color: var(--readable-color-on-light, #343536);
        overflow-x: hidden;

        --transparent-gradient: linear-gradient(0deg, transparent, transparent);

        background-image:
          linear-gradient(
            var(--theme-background-color-opacity-85),
            var(--theme-background-color-opacity-90)
          ),
          var(--theme-background-image-url, ""),
          var(--theme-background-image-placeholder-url, var(--transparent-gradient));
        background-attachment: fixed;
        background-size: cover;

        &::before {
          content: "";
          position: fixed;
          z-index: 0;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          backdrop-filter: blur(0.125rem);
        }
      }

      .background-light {
        --readable-color: var(--readable-color-on-light, #343536);
      }

      .background-dark {
        --readable-color: var(--readable-color-on-dark, #FFFFFF);
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        margin: 0;
      }

      @media screen and (-webkit-min-device-pixel-ratio: 2),
        screen and (min-resolution: 2dppx) {
        body {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
        }
      }

      @media screen and (min-width: 50em) {
        :root {
          font-size: 115%;
        }
      }

      @media screen and (min-width: 70em) {
        :root {
          font-size: 130%;
        }
      }

      input, button, a {
        outline-color: var(--theme-foreground-color);
        // Disables delay on touch devices
        touch-action: manipulation;
      }
    `}
  />
);
